import {get, postWithToken} from "./Request";

const corePath = "Post/";

export async function Get(id, token, edit) {
    return await get(`${corePath}Get?menuId=${id}&isEdit=${!!edit}`);
}

export async function Search(query) {
    return await get(`${corePath}Search?query=${query}`);
}

export async function CreateOrUpdate(model, token) {
    return await postWithToken(`${corePath}CreateOrUpdate`, token, model);
}

